<template>
  <v-radio-group :hide-details="'auto'" class="va-radio-card__group" row v-model="selected">
    <div
      @click="selectCard(item.value)"
      :class="['va-radio-card', selected === item.value ? 'va-radio-card--active' : '']"
      v-for="item in items"
      :key="item.value">
      <div class="va-radio-card__image">
        <img :draggable="false" :src="item.image" :alt="item.label" />
      </div>
      <v-radio class="va-radio-card__input" :value="item.value" :label="`${item.label}`"></v-radio>
    </div>
  </v-radio-group>
</template>

<script>
  export default {
    name: "VaRadioImageCard",
    props: {
      value: {
        required: true,
        default: "",
      },
      items: {
        type: Array,
        default: () => [],
        required: true,
      },
    },
    data() {
      return {
        selected: null,
      };
    },
    beforeMount() {
      if (this.value) {
        this.selected = this.value;
      }
    },
    methods: {
      selectCard(value) {
        this.selected = value;
        this.$emit("input", value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-radio-card__group {
    margin-top: 0;
    padding-top: 0;
    &::v-deep {
      .v-input--radio-group__input {
        gap: 22px;
      }
    }
    .va-radio-card {
      border: 1px solid get-color("border");
      border-radius: 6px;
      padding: 16px 11px;
      cursor: pointer;
      flex: none;
      flex-grow: 1;
      &.va-radio-card--active {
        border: 1px solid get-color("primary");
      }
      .va-radio-card__image {
        display: flex;
        justify-content: center;
        margin-bottom: 22px;
        img {
          height: 196px;
          width: 316px;
        }
      }

      .va-radio-card__input {
        &::v-deep {
          .v-input--selection-controls__input {
            margin-right: 15px;
          }
          .v-icon {
            color: get-color("icon");
          }
          label.v-label {
            color: get-color("headline");
            @include text-subtitle-1();
          }
        }
      }
    }
  }
</style>
